import { render, staticRenderFns } from "./ModalDeveloper.vue?vue&type=template&id=2e5e84ff&scoped=true&"
import script from "./ModalDeveloper.vue?vue&type=script&lang=js&"
export * from "./ModalDeveloper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5e84ff",
  null
  
)

export default component.exports